/**
 * trackEvent — helper pentru trimiterea de evenimente business către pixel-ul
 * de tracking al platformei (/api/track/pixel.gif).
 *
 * Uz:
 *   import { trackEvent } from "@/lib/track";
 *   trackEvent("render.start", { sim_type: "EXTERIOR" });
 *   trackEvent("pdf.download.ghid_sales");
 *   trackEvent("reco.sent", { partner_email: "..." });
 *
 * Fire-and-forget: request-ul se face cu Image (nu Promise), deci nu blochează
 * niciodată UI-ul. Erorile de rețea sunt silențioase. Query string primeşte:
 *   event   — cod scurt kebab-cased (ex: render.start, vision.feedback.submit)
 *   page    — pathname curent (auto-populat)
 *   ref     — informaţie contextuală opţională (JSON stringified, trunchiat 200)
 *
 * Toate evenimentele custom au prefix diferit de "pageview" pentru a fi
 * distincte în /api/admin/tracking/stats → by_event.
 */
import { API_BASE } from "@/lib/api";
import { isAnalyticsEnabled } from "@/components/CookieBanner";

// Sanitizează valoarea pentru query string (max 200 char, JSON encoded)
function stringifyRef(extra) {
  if (!extra) return "";
  try {
    const s = JSON.stringify(extra);
    return s.length > 200 ? s.slice(0, 197) + "..." : s;
  } catch {
    return String(extra).slice(0, 200);
  }
}

export function trackEvent(event, extra = null) {
  if (!event) return;
  if (!isAnalyticsEnabled()) return; // iter96 · respect cookie consent
  try {
    const page = (typeof window !== "undefined" ? window.location.pathname : "") || "";
    const params = new URLSearchParams({ event, page });
    const ref = stringifyRef(extra);
    if (ref) params.set("ref", ref);
    const img = new Image();
    img.src = `${API_BASE}/track/pixel.gif?${params.toString()}&t=${Date.now()}`;
  } catch {
    // never fail on tracking
  }
}

export default trackEvent;
